/* esm.sh - rxjs@7.8.2/dist/esm/internal/NotificationFactories */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/NotificationFactories.mjs";
